import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en metodo-page.tsx y se descarga aparte (code-split) — así visitar
// el home u otra página pública no baja el bundle de esta (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/metodo",
  head: () => ({
    meta: seoMeta({
      title: "Método de Calistenia — Calistenia Progresiva",
      description: "Método de calistenia con progresiones estructuradas: filosofía, etapas y beneficios de entrenar con propósito.",
      path: "/metodo",
    }),
    links: [canonicalLink("/metodo")],
  }),
  component: lazyRouteComponent(() => import("./metodo-page"), "MetodoPage"),
});
